import { FormattedMessage } from 'react-intl'
import React, { useRef } from 'react'
import { getDivingHistory } from '../common/utils'
import AdsBanner from './AdsBanner'
import { useHomeBanner } from '../../services/hooks/club'
import { useHistory } from 'react-router-dom'

import styles from './Header.module.css'

const getAvatar = (profile) => profile?.wechat?.headimgurl || 'https://assets.padi.com.cn/assets/images/avatar.jpg'

export default function UserHeader({ ecards, profile }) {
  const adsRef = useRef()
  const { data } = useHomeBanner()
  const { push } = useHistory()

  return (
    <>
      {data && data.carousel.length > 0 && (
        <div ref={adsRef}>
          <AdsBanner bannerList={data.carousel} />
        </div>
      )}
      <div className={styles.header}>
        <div
          className={styles.left}
          style={{ background: `url(${getAvatar(profile)})`, backgroundSize: 'contain' }}
        ></div>
        <div className={styles.right}>
          <div className={styles['user-info']}>
            <div className={styles['user-name']}>
              {profile?.wechat?.nickname || <FormattedMessage id="userHeader-userHeaderMsg" />}
            </div>
            {profile.publicWelfareCertificateCode && (
              <div
                className={styles['pw-info']}
                onClick={() =>
                  push(`/pw_cert?nickName=${profile?.wechat?.nickname}&no=${profile.publicWelfareCertificateCode}`)
                }
              >
                <span className={styles['pw-name']}>海洋守蔚者</span>
                <span className={styles['pw-number']}>{profile.publicWelfareCertificateCode}</span>
              </div>
            )}
          </div>
          <div className={styles['certs-info']}>
            <FormattedMessage
              id="userHeader-userheaderamount"
              values={{
                year: <span className={styles.year}>{getDivingHistory(ecards) || ''}</span>,
                certAmount: <span className={styles.count}>{ecards.length}</span>,
                count: ecards.length > 1 ? 's' : '',
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}
